'use client';

import { createContext } from 'react';

/**
 * The Convex identity the client has confirmed for this session, or null while
 * signed out or unconfirmed. Kept in a dependency-free module so low-level
 * hooks (signed-URL caches) can read it without importing the workspace
 * boundary and its UI.
 */
export const ConfirmedConvexIdentityContext = createContext<string | null>(
  null
);

/** The admitted workspace (identity + slug) for routes under a workspace. */
export const ActiveWorkspaceContext = createContext<{
  userId: string;
  orgSlug: string;
} | null>(null);
